import React from 'react';
import {SelectInput} from 'react-admin';

const type = [
    {id: 'Giải Nhất', name: 'Giải Nhất'},
    {id: 'Giải Nhì', name: 'Giải Nhì'},
    {id: 'Giải Ba', name: 'Giải Ba'},
    {id: 'Giải Khuyến khích', name: 'Giải Khuyến khích'},
]

export const GiaiHsGioiInput = (props) => (
    <SelectInput source={props.source} choices={type} {...props} />
)
